<template>
  <div class="hypo-scenario-analysis">
    <mwc-pp-scenario-analysis
      v-if="loaded"
      :mwc-id="`mwcPpScenarioAnalysis__${generateUniqueId()}`"
      :risk-model-id="options.riskModelId"
      :start-value="options.initialInvestmentAmount"
      :config.prop="ppScenarioAnalysisConfig"
      :portfolios.prop="scenarioPortfolios"
    >
    </mwc-pp-scenario-analysis>
  </div>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import defaultConfig from './_config';
import 'mwc-pp-sa-dial/dist/mwc-pp-sa-dial.css';
import 'mwc-pp-sa-card/dist/mwc-pp-sa-card.css';
import 'mwc-pp-scenario-analysis/dist/mwc-pp-scenario-analysis.css';
import 'mwc-pp-sa-dial';
import 'mwc-pp-sa-card';
import 'mwc-pp-sa-data';
import 'mwc-pp-scenario-analysis';

const { colors, riskModelId } = defaultConfig.settings;
let uniqueId = 0; // used to generate multiple instance, avoid mwc cache.

export default {
  name: 'hypo-scenario-analysis',
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    mwcId: {
      type: String,
      required: true,
    },
    config: {
      type: [String, Object],
      default: () => {},
    },
    environment: {
      type: String,
    },
    hypoFileType: {
      type: Number,
    },
    SATokenSourceOptions: {
      type: Object,
      default: () => {
        return {
          /* eslint-disable no-unused-vars */
          refreshToken: callback => {
            throw new Error(
              'refreshToken method need to implemented, token need to be passed to callback.'
            );
          },
        };
      },
    },
    portfolios: {
      type: Array,
      default: () => [],
    },
    initialInvestmentAmount: {
      type: Number,
    },
    riskModelId: {
      type: String,
      default: riskModelId,
    },
    colors: {
      type: Array,
      default: () => colors,
    },
  },
  data() {
    return {
      defaultConfig: {
        intlNamespace: this.mwcId,
        ...defaultConfig,
      },
      loaded: false,
      ppScenarioAnalysisConfig: null,
    };
  },
  computed: {
    overrideLabels() {
      if (this.isInvestmentFlow) {
        return {
          unsupportedHoldings: this.translate('unsupportedInvestment'),
        };
      }
      return null;
    },
    isPortfolioComparison() {
      return this.options.hypoFileType === 1;
    },
    isInvestmentFlow() {
      return this.options.hypoFileType === 2;
    },
    scenarioPortfolios() {
      return (
        this.options.portfolios &&
        this.options.portfolios.map((portfolio, i) => {
          const { type, index, ...portfolioData } = portfolio;
          if (type === 'portfolio') {
            return {
              category: this.isPortfolioComparison ? `portfolio${index + 1}` : `portfolio`,
              ...portfolioData,
            };
          }
          if (type === 'holding') {
            const isInvestmentComparison =
              this.isInvestmentFlow &&
              this.options.portfolios.filter(item => item.type === 'holding').length > 1;
            return {
              category: isInvestmentComparison ? `investment${i + 1}` : `investment`,
              ...portfolioData,
            };
          }
          return {
            category: this.isPortfolioComparison ? `benchmark${index + 1}` : `benchmark`,
            ...portfolioData,
          };
        })
      );
    },
  },
  created() {
    const tokenSource = {
      ...this.settings.SATokenSourceOptions,
      ...this.options.SATokenSourceOptions,
    };
    window.mwc.dataAccess.registerTokenSource(tokenSource);
    this.initConfig();
    this.loaded = true;
  },
  methods: {
    initConfig() {
      this.ppScenarioAnalysisConfig = {
        settings: {
          languageId: this.settings.languageId,
          environment: this.options.environment.toLowerCase(),
          showMacroShockScenarios: this.settings.showMacroShockScenarios,
          showMarketShockScenarios: this.settings.showMarketShockScenarios,
          tabsContent: this.settings.tabsContent,
          timeSeriesLineChartSettings: {
            colors: this.options.colors,
          },
        },
      };
      if (this.overrideLabels) {
        this.ppScenarioAnalysisConfig = {
          ...this.ppScenarioAnalysisConfig,
          labels: {
            en: this.overrideLabels,
            'en-US': this.overrideLabels,
          },
        };
      }
    },
    generateUniqueId() {
      const uId = uniqueId;
      uniqueId += 1;
      return uId;
    },
  },
};
</script>

<style lang="scss">
@import '~@mds/constants';
@import './styles/variables';

.#{$component-ns} {
  background-color: $mds-background-color-white;
  height: 100%;
}
</style>
